import styled from 'styled-components';

export const EmptyBlocContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  align-items: center;
  text-align: center;
  .bloc-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    width: 50%;
  }
`;
export const Container = styled.div`
  .box-content {
    display: flex;
    flex-direction: row;
    padding: 15px;
    align-items: flex-start;
    width: 100%;
  }
  .icon-avatar {
    align-items: flex-start;
  }
  .typography-date {
    align-items: center;
  }
  .typography-title {
    opacity: 0.65;
    font-size: 12px;
    line-height: 16px;
  }
  .box-name {
    display: flex;
    flex-direction: column;
    padding-left: 15px;
    align-items: flex-start;
  }
  .own-text {
    background-color: #00194d;
    color: #ffffff;
  }
  .paper-box {
    padding: 10px;
    border-radius: 10px;
    max-width: 300px;
  }
`;
